import { Component, Input, OnInit, SimpleChanges, HostBinding } from '@angular/core';
import { TypesenseService } from 'src/app/shared/services/typesense.service';

@Component({
    selector: 'app-stock-press-releases',
    templateUrl: './stock-press-releases.component.html',
    styleUrls: ['./stock-press-releases.component.scss'],
    standalone: false
})
export class StockPressReleasesComponent implements OnInit {
   public news: any;
   public showNews: boolean = false;
   newsLoader: boolean = true;

   @Input() symbol: string | undefined;
   @Input() tickers: string[] | undefined;
   @Input() handleHeader! : string;

   constructor(
      private typesenseService: TypesenseService,
   ) {}

   ngOnChanges(changes: SimpleChanges): void {
      if (this.symbol) {
         this.stockPressReleases(this.symbol);
      }
   }

   ngOnInit(): void {}

   trackByNewsId(index: number, news: any) {
      return news.Id;
   }

   private stockPressReleases(ticker: string) {
      this.newsLoader = true
      this.typesenseService.getPressRelease(ticker).then((data: any) => {
         this.news = data.majorDevelopment;
         // console.log(this.news);

      }).catch((error: any) => {
         console.log(error);
      }).finally(() => {
         this.newsLoader = false;
      });
   }

   getFilteredNews() {
      if(this.showNews) {
         return this.news
      } else {
         return this.news.slice(0, 6)
      }
   }

   @HostBinding('class')

   get headerVisibility(): string {
      if (this.handleHeader === 'show') {
         return 'show-header';
      } else if (this.handleHeader === 'hide') {
         return 'hide-header';
      } else {
         return '';
      }
   }
}
